// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"S_dC","slider__element":"S_dD","itemSlider":"S_dF","itemSlider__slideWrapper":"S_dG","itemSlider__pagination":"S_dH","activeSlide":"S_dJ"};